import { ServerRequest } from '@nutshell/core';

class VueServerRequest {

    constructor(options) {
        this.instance = new ServerRequest(options);
    }

    getInstance() {
        return this.instance;
    }
}

/**
 * Installing the ServerRequest as a plugin for Vue
 * @param  {Vue} Vue
 */
VueServerRequest.install = (Vue) => {

    Vue.mixin({

        /**
         * Find the server class and add as variabele to the component for easy access
         */
        beforeCreate () {

            if ( this.$options.xhr instanceof VueServerRequest ) {
                this._xhr = this.$options.xhr.instance;
            }
            else {
                this._xhr = (this.$parent && this.$parent._xhr) || this;
            }
        }

    });

    Object.defineProperty(Vue.prototype, '$xhr', {
        get () { return this._xhr; }
    });
}

export default VueServerRequest;
